import { useCallback, useEffect, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'

import { usePageTitle } from '../../hooks/usePageTitle'
import { PSApplication } from '../app/PSApplication'
import Paragraph from '../app/design/Paragraph'
import { ConfirmationModal } from '../common/modals/ConfirmationModal'
import { SelectPlanPage } from '../settings/SelectPlanPage'

export const WelcomeBackSelectPlanPage = () => {
    const navigate = useNavigate()
    const [searchParams, setSearchParams] = useSearchParams()
    const user = PSApplication.me()
    const [showCancellationDoneModal, setShowCancellationDoneModal] = useState(false)

    const onNext = useCallback(() => {
        // this will reload the page, which is required to register routes
        navigate(0)
    }, [navigate])

    useEffect(() => {
        if (searchParams.get('showCancellationDone') !== 'true') return
        setShowCancellationDoneModal(true)
        setSearchParams('')
    }, [searchParams])

    usePageTitle('Select plan')

    const backPath = searchParams.get('back') ?? '/login'

    return (
        <>
            {!showCancellationDoneModal && (
                <SelectPlanPage
                    context={user?.lastSyncDate ? 'comeback' : 'new'}
                    onNext={onNext}
                    showHeader
                    onBack={{
                        label: 'Back',
                        href: backPath,
                    }}
                />
            )}

            <ConfirmationModal
                size="medium"
                title="All done!"
                isOpen={showCancellationDoneModal}
                onClose={() => navigate('/login', { replace: true })}
                onConfirm={() => navigate('/login', { replace: true })}
                shouldHideCancelButton
                cancelButtonText="Close"
                confirmButtonText="Done"
            >
                <Paragraph>
                    Your subscription was successfully canceled. We're sorry to see you go. If you
                    change your mind in the next 30 days, we might be able to recover your premium
                    number.
                </Paragraph>
            </ConfirmationModal>
        </>
    )
}
